import { Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import { useSnapshots } from 'features/snapshots/api/getSnapshots';

interface Props {
  analyzerId: number;
  users: { id: number; snapshot_id: number }[];
}

const TimeshareTotalSweepTime = ({ analyzerId, users }: Props) => {
  const { data: snapshots } = useSnapshots({ analyzerId });
  const userSnapshotIds = users?.map((user: any) => user.snapshot_id);
  const totalSweepTime = snapshots
    ?.filter((snapshot) => userSnapshotIds?.includes(snapshot.id))
    ?.map((snapshot) => snapshot.last_reported_sweep_time)
    ?.reduce((prev, current) => Number(prev) + Number(current), 0);

  return (
    <Typography color={grey[500]} textAlign='center'>
      Total Sweep Time: {totalSweepTime} ms
    </Typography>
  );
};

export default TimeshareTotalSweepTime;
